import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const SurveyApprovalForm = ({ customerMap, selectedSurvey, handleApproveSubmit, handleSurveyDelete }) => {
    const { t } = useTranslation();
    const [selectedProject, setSelectedProject] = useState('');
    const [selectedDrillhole, setSelectedDrillhole] = useState('');

    useEffect(() => {
        const destination = predictDestination();
        if (destination.project && destination.drillhole) {
            setSelectedProject(destination.project);
            setSelectedDrillhole(destination.drillhole);
        } else {
            setSelectedProject('');
            setSelectedDrillhole('');
        }
    }, [selectedSurvey, customerMap]); // eslint-disable-line react-hooks/exhaustive-deps -- predictDestination is pure over selectedSurvey + customerMap which are already in deps

    const handleProjectChange = (event) => {
        if (event.target.value === '') {
            return;
        }
        setSelectedProject(event.target.value);
        setSelectedDrillhole('');
    }

    const handleDrillholeChange = (event) => {
        setSelectedDrillhole(event.target.value);
    }

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (!selectedProject || !selectedDrillhole) {
            return;
        }
        handleApproveSubmit(selectedProject, selectedDrillhole);
    }

    const handleDeleteClick = (event) => {
        event.preventDefault();
        handleSurveyDelete();
    }

    function predictDestination() {
        let destination = {
            project: '',
            drillhole: ''
        }
        if (!selectedSurvey || !selectedSurvey.fileName) {
            return destination;
        }
        let nameParts = selectedSurvey.fileName.split(' - ');
        if (nameParts.length < 3) {
            return destination;
        }
        let projectName = nameParts[0];
        let drillholeName = nameParts[1];
        let destinationProject = customerMap.projects.find(p => p.name === projectName);
        if (!destinationProject) {
            return destination;
        }
        destination.project = destinationProject.name;
        if (!destinationProject.drillholes) {
            return destination;
        }
        let destinationDrillhole = destinationProject.drillholes.find(d => d.name === drillholeName);
        if (!destinationDrillhole) {
            return destination;
        }
        destination.drillhole = destinationDrillhole.name;
        return {
            project: destinationProject.name,
            drillhole: destinationDrillhole.name
        };
    }




    return (
        <div>
        <form onSubmit={handleFormSubmit}>
            <div className="form-group">
                <label htmlFor="projectSelect">{t('approval.project')}</label>
                <select className="form-select" id="projectName" value={selectedProject} onChange={handleProjectChange}>
                    <option value="">{t('projects.selectProject')}</option>
                    {customerMap.projects && customerMap.projects.map((project) => {
                        return <option key={project.name} value={project.name}>{project.name}</option>;
                    })}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="drillholeSelect">{t('approval.drillhole')}</label>
                <select className="form-select" id="drillholeName" value={selectedDrillhole} onChange={handleDrillholeChange}>
                    <option value="">{t('approval.selectDrillhole')}</option>
                    {customerMap.projects && customerMap.projects.find(p => p.name === selectedProject) && customerMap.projects.find(p => p.name === selectedProject).drillholes.map((drillhole) => {
                        return <option key={drillhole.name} value={drillhole.name}>{drillhole.name}</option>;
                    })}
                </select>
            </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '16px' }}>
                <button className="btn btn-primary" style={{ marginRight: 'auto' }} onClick={handleDeleteClick} disabled={!selectedSurvey.key}>{t('common.delete')}</button>
                <span style={{ display: 'inline-block', width: '32px' }}></span>
                <button type="submit" className="btn btn-primary" disabled={!selectedSurvey.key || !selectedProject || !selectedDrillhole}>{t('approval.approve')}</button>
            </div>
            </form>
        </div>
    );
}
